module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/star-fill-a6891f2623626ef24e2b5fa939ae5bc2.svg";